import customFetchBase from "../../../principal/customFetchBase";
import { createApi } from "@reduxjs/toolkit/query/react";

export const titulosApi = createApi({
  reducerPath: "titulosApi",
  baseQuery: customFetchBase,
  tagTypes: ["Titulos"],
  endpoints: () => ({}),
});
